import { SupabaseSelectResult } from "@/lib/supabase/supabase-postgrest";

export type ItemUOMSelectResult = SupabaseSelectResult<"ItemUOM", typeof itemUOMSelect, ItemUOMSelectRelatedTables>;

export type ItemUOMSelectRelatedTables = "UOM";

export const itemUOMSelect = `
  conversion,
  isBase,
  purchaseCost,
  uom:UOM!inner(id, name, abbreviation)
`;

/**
 * Calculate the base quantity of an item based on the specified UOM.
 *
 * @param uomQuantity The quantity of the item in the specified UOM.
 * @param itemUOM The item UOM selected for the item.
 * @returns The base quantity of the item.
 */
export function calculateBaseQuantity(uomQuantity: number, itemUOM: ItemUOMSelectResult | null): number {
  // If itemUOM is null, assume the base UOM and return the original quantity
  if (!itemUOM) return uomQuantity;

  // Otherwise, calculate the base quantity using the conversion factor in the ItemUOM
  const { isBase, conversion } = itemUOM;
  return isBase ? uomQuantity : uomQuantity * conversion;
}

export function convertQuantityToUOM(
  quantity: number,
  sourceUOM: ItemUOMSelectResult | null,
  targetUOM: ItemUOMSelectResult | null,
): number {
  // Convert the source quantity to the base UOM
  const baseQuantity = calculateBaseQuantity(quantity, sourceUOM);

  // If the target UOM is null, assume the target is the base UOM
  if (!targetUOM) return baseQuantity;

  // Otherwise, convert the base quantity to the target UOM
  return baseQuantity / targetUOM.conversion;
}
